import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function SdsDocIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 21.09 21.09"
        {...props}
      >
        <path
          fill="#0F69AF"
          d="M.3 9.84 3.84 6.3a.996.996 0 0 1 1.41 0l3.54 3.54c.39.39.39 1.02 0 1.41l-3.54 3.54a.996.996 0 0 1-1.41 0L.3 11.26c-.39-.39-.39-1.03 0-1.42"
        />
        <path
          fill="#E61E50"
          d="M6.31 3.83 9.84.3a.996.996 0 0 1 1.41 0l3.54 3.54c.39.39.39 1.02 0 1.41l-3.54 3.54a.996.996 0 0 1-1.41 0L6.31 5.25c-.39-.39-.39-1.03 0-1.42"
        />
        <path
          fill="#F2F2F2"
          d="m6.31 15.85 3.54-3.54a.996.996 0 0 1 1.41 0l3.54 3.54c.39.39.39 1.02 0 1.41l-3.54 3.54a.996.996 0 0 1-1.41 0l-3.54-3.54a.996.996 0 0 1 0-1.41"
        />
        <path
          fill="#FFC832"
          d="m12.32 9.84 3.54-3.54a.996.996 0 0 1 1.41 0l3.54 3.54c.39.39.39 1.02 0 1.41l-3.54 3.54a.996.996 0 0 1-1.41 0l-3.54-3.54a.996.996 0 0 1 0-1.41"
        />
      </svg>
    </Icon>
  )
}
export default SdsDocIcon
